function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#4BB4FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.7064 15.432L10.3384 16.712H13.0104L12.6424 15.432C12.4717 14.8773 12.3064 14.3067 12.1464 13.72C11.997 13.1333 11.8477 12.552 11.6984 11.976H11.6344C11.485 12.5627 11.3357 13.1493 11.1864 13.736C11.037 14.312 10.877 14.8773 10.7064 15.432ZM7.20237 21L10.6104 10.536H12.7864L16.1944 21H14.2424L13.4264 18.168H9.90638L9.09038 21H7.20237ZM17.4843 21V10.536H23.7883V12.104H19.3403V14.776H23.1003V16.344H19.3403V19.432H23.9483V21H17.4843Z",
  fill: "white"
});

var SvgAvatarName = function SvgAvatarName(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatarName, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatarName.5c817f50.svg";
export { ForwardRef as ReactComponent };